import { type UserDto } from '../../hooks/useGetUsers';
import { type HttpClient } from '../useHttpClient';

type PaginatedUsersResponse = {
  data: UserDto[];
  next?: string;
};

export type FetchUsersParams = {
  query: string | undefined;
  limit?: number;
  /** Filter users who are members of this channel */
  memberOfChannel?: string;
  /** Filter users who are operators of this channel */
  operatorInChannel?: string;
  /** Filter users who are muted in this channel */
  mutedInChannel?: string;
  /** Filter users who are not members of this channel */
  notMemberOfChannel?: string;
  /** Filter users who are not operators of this channel */
  notOperatorInChannel?: string;
  pageParam?: string;
};

export const fetchUsers =
  (httpClient: HttpClient) =>
  async ({
    pageParam,
    limit,
    query,
    memberOfChannel,
    operatorInChannel,
    mutedInChannel,
    notMemberOfChannel,
    notOperatorInChannel,
  }: FetchUsersParams) => {
    const params = new URLSearchParams({
      limit: `${limit ?? 50}`,
    });

    if (query) params.append('query', query);
    if (pageParam) params.append('after', pageParam);
    if (memberOfChannel) params.append('memberOfChannel', memberOfChannel);
    if (operatorInChannel)
      params.append('operatorInChannel', operatorInChannel);
    if (mutedInChannel) params.append('mutedInChannel', mutedInChannel);
    if (notMemberOfChannel)
      params.append('notMemberOfChannel', notMemberOfChannel);
    if (notOperatorInChannel)
      params.append('notOperatorInChannel', notOperatorInChannel);

    const response = await httpClient.api(`/users/search?${params}`, {
      method: 'GET',
    });

    const { data: usersDataPage, next } =
      response.json as PaginatedUsersResponse;

    return {
      data: usersDataPage,
      next,
    };
  };
